import { useLocation } from "react-router-dom";

const useParams = (url) =>
  new URLSearchParams(url ? url : useLocation().search);
export default useParams;
